<template>
  <div>
    <el-dialog
      class="paid-tip-modal"
      width="264px"
      :visible.sync="resultModalVisible"
      :show-close="false"
      append-to-body
    >
      <div class="paid-tip-modal-inner">
        <div class="tip-img">
          <img :src="curRedeem.url" alt="" />
        </div>
        <div class="text">{{ curRedeem.text }}</div>
        <div class="btn" @click="closeTipModal">
          {{ getBtnText }}
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="akadm-middle-modal"
      :visible="visible"
      :close-on-click-modal="false"
      @close="closeModal"
    >
      <div class="paid-top-title">
        <p
          class="paid-vip"
          v-if="user_expired_data && user_expired_data.expired_type == 1"
        >
          <i></i
          ><span
            >您的体验期还有{{ enable_days }}天（{{
              enable_end_time
            }}）即将结束</span
          >
        </p>
        <p class="paid-vip" v-else-if="user_expired_data.expired_type == 2">
          <i class="is-expired"></i
          ><span>您的 VIP 权限于（{{ enable_end_time }}）已到期</span>
        </p>
        <p class="paid-vip" v-else>
          <i class=""></i><span>您的账号将于（{{ enable_end_time }}）到期</span>
        </p>
        <p v-if="user_expired_data && user_expired_data.expired_type == 1">
          — 续费成功即可畅享会员特权，会员有效期顺延 —
        </p>
      </div>
      <div class="paid-top-tips">
        <p>
          您已获得永久会员权益，可永久免费查看、挑选、转发及上课使用系统全部资源。开通VIP会员，可以在会员权限外，获得资源上传、下载、组卷打印、个人空间等VIP权限。
        </p>
      </div>
      <div class="paid-center-content">
        <div class="paid-meal-wrap">
          <div >VIP会员费用原价300元/年，现推出多重特惠大礼包<br/>
            1、原价三折后特惠价90元/年<br/>
            2、特惠价买一年送一年，折上再折<br/>
            3、个人云空间送500G超大容量，电脑资源全上云<br/>
            4、团购10人起特惠价上再八五折（加首页爱米客服微信）</div>
          <div class="paid-meal paid-common-box">
            <!--          <p class="paid-title-p">续费套餐选择：</p>-->

            <div class="meal-list">
              <div
                  class="meal-list-item"
                  :class="{ active: curProduct.id == item.id }"
                  v-for="(item,i) in payProductList"
                  :key="item.id"
                  @click="changeProduct(item)"
              >
                <p class="pay-month">{{ item.title }}</p>
                <p class="pay-amount">
                  ￥<span>{{ item.current_price / 100 }}</span>
                </p>
                <p class="cut-count">立省{{ item.discount / 100 }}元</p>
              </div>
            </div>
          </div>

        </div>
        <div class="paid-redemption-code paid-common-box">
          <p class="paid-title-p">
            会员码兑换 <span>兑换成功即可畅享会员特权，会员有效期顺延</span>
          </p>
          <div class="redemption-code-input">
            <el-input
              v-model="code_input"
              placeholder="请输入兑换码，区分大小写"
              clearable
            ></el-input>
            <span @click="redeem" :class="{ active: code_input }">兑换</span>
          </div>
        </div>
        <div class="paid-methods paid-common-box">
          <p class="paid-title-p">支付方式</p>
          <div class="paid-methods-way active">
            <i></i>
            <span>微信扫码支付</span>
          </div>
        </div>
        <div class="paid-order-info paid-common-box">
          <p class="paid-title-p">订单信息</p>
          <p>
            会员时长：<span>{{ curProduct.title }}</span> （有效期至{{
              curProduct.enable_end_time
            }}）
          </p>
        </div>
        <div class="paid-code-img" v-loading="loading">
          <h6>
            订单总价：<span>¥</span><i>{{ curProduct.current_price / 100 }}</i>
          </h6>
          <img :src="qrCodeUrl" alt="" />
          <p>请使用微信扫码支付</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import img1 from "@/assets/images/success_pic@2x.png";
import img2 from "@/assets/images/fail_pic@2x.png";
import img3 from "@/assets/images/warming_pic@2x.png";
const exchangeRedeemCodeMap = {
  0: {
    url: img1,
    text: "支付成功",
  },
  1: {
    url: img1,
    text: "兑换成功",
  },
  2: {
    url: img2,
    text: "支付失败了……",
  },
  3: {
    url: img3,
    text: "兑换失败，该活动已结束。",
  },
  4: {
    url: img3,
    text: "兑换码已被使用，请重新输入。",
  },
  5: {
    url: img3,
    text: "兑换码错误",
  },
  6: {
    url: img3,
    text: "兑换码无效",
  },
};
import {
  getPayProducts,
  getOrderQrCode,
  checkOrderStatus,
  exchangeRedeemCode,
} from "@/api/commonApi";
import {getStuQr} from "../../page/common/login/loginApi";

export default {
  name: "paidModal",
  data() {
    return {
      stu_qr_code:'',
      payStatusTimer: null,
      loading: false,
      order_no: null,
      qrCodeUrl: null,
      curProduct: {
        id: null,
      },
      curRedeem: {
        code_type: "",
        url: "",
        text: "",
      },
      payProductList: [], //付费套餐列表
      show_paid_modal: false, //是否显示付费弹窗
      code_input: "", //兑换码
      resultModalVisible: false,
      paid_tip: "",
    };
  },
  computed: {
    visible() {
      return this.$store.getters.getElectronPaidModalVisible;
    },
    user_expired_data() {
      return this.$store.getters.getElectronAccountInfo;
    },
    enable_days() {
      let expired_date = new Date(
        this.user_expired_data.enable_end_time * 1000
      ).getDate();
      let today = new Date().getDate();
      return expired_date - today;
    },
    enable_end_time() {
      if (this.user_expired_data && this.user_expired_data.enable_end_time) {
        return this.format(
          this.user_expired_data.enable_end_time,
          "yyyy-MM-dd"
        );
      }
      return "";
    },
    getBtnText() {
      return [0, 1, 3, 4].includes(this.curRedeem.code_type)
        ? "知道了"
        : "重试一下";
    },
  },
  watch: {
    visible() {
      this.removeTimer();
      if (this.visible === false) {
        setTimeout(() => {
          this.removeTimer();
        }, 1000);
      } else {
        this.getPayProductsAction();
      }
    },
  },
  methods: {
    getStuQrFun() {
      getStuQr().then((res) => {
        if (res.errCode == 0) {
          this.stu_qr_code = res.data.img
          console.log(res.data, 45454545)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    closeTipModal() {
      this.resultModalVisible = false;
    },
    async redeem() {
      if (this.code_input.length > 0) {
        let code_type = 2;
        try {
          const res = await exchangeRedeemCode({
            code: this.code_input,
          });
          if (res.errCode == 0) {
            code_type = res.data.code_type;
          }
        } catch (err) {}
        this.curRedeem = exchangeRedeemCodeMap[code_type];
        this.curRedeem.code_type = code_type;
        this.resultModalVisible = true;
        if (code_type == 1) {
          // 付费成功,重新获取账户信息
          this.paidSuccess();
        }
      }
    },
    paidSuccess() {
      this.$store.dispatch("PAID_MODAL_VISIBLE", false);
      this.$store.dispatch("ELECTRON_ACCOUNT_INFO");
    },
    closeModal() {
      this.$cookies.set("paid_modal_visible", false);
      this.$store.dispatch("PAID_MODAL_VISIBLE", false);
    },
    getPayProductsAction() {
      getPayProducts()
        .then((res) => {
          if (res.errCode == 0) {
            this.payProductList = res.data;
            this.changeProduct(
              this.payProductList[this.payProductList.length - 1]
            );
          }
        })
        .catch((err) => {});
    },
    changeProduct(item) {
      this.curProduct = item;
      let data = {
        product_id: item.id,
      };
      this.loading = true;
      this.removeTimer();
      getOrderQrCode(data)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.order_no = res.data.order_no;
            this.qrCodeUrl = res.data.qr_code;
            this.checkOrderdebounce(this.checkOrderStatusAction)();
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    checkOrderdebounce(fn) {
      return () => {
        this.removeTimer();
        this.payStatusTimer = setTimeout(() => {
          fn.apply(this, arguments);
        }, 1 * 1000);
      };
    },
    checkOrderStatusAction() {
      let data = {
        order_no: this.order_no,
      };
      this.removeTimer();
      checkOrderStatus(data)
        .then((res) => {
          if (res.errCode == 0) {
            // status 0未付款  1付款成功
            this.order_no = res.data.order_no;
            if (res.data.status == 1) {
              let code_type = 0;
              this.curRedeem = exchangeRedeemCodeMap[code_type];
              this.curRedeem.code_type = code_type;
              this.resultModalVisible = true;
              this.paidSuccess();
              return;
            }
            this.checkOrderdebounce(this.checkOrderStatusAction)();
          }
        })
        .catch((err) => {
          this.removeTimer();
        });
    },
    removeTimer() {
      if (this.payStatusTimer) {
        clearTimeout(this.payStatusTimer);
        this.payStatusTimer = null;
      }
    },
  },
  mounted() {
    this.getStuQrFun();
  }
};
</script>

<style scoped lang="scss">
.akadm-middle-modal {
  /deep/.el-dialog__headerbtn {
    right: 0.16rem;
    top: 0.16rem;
  }
  /deep/.el-icon-close {
    font-size: 0.2rem;
  }
  /deep/.el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8.46rem;
    //height: 85%;
    margin-top: 0 !important;
    overflow: hidden;
  }
  /deep/.el-dialog__body {
    display: flex;
    flex-direction: column;
    padding: 0 0.4rem 0.2rem 0.4rem;
    height: 100%;
    overflow: hidden;
  }
}
.paid-tip-modal {
  /deep/ {
    .el-dialog {
      border-radius: 9px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 8.46rem;
      margin-top: 0 !important;
      overflow: hidden;

      .el-dialog__header {
        padding: 0;
      }

      .el-dialog__body {
        padding-top: 24px;
        padding-bottom: 24px;
      }

      .tip-img {
        width: 180px;
        height: 132px;
        margin: auto;

        img {
          width: 100%;
        }
      }

      .text {
        margin-top: 16px;
        text-align: center;
        font-size: 16px;
        color: #606060;
      }

      .btn {
        margin: 24px auto 0 auto;
        cursor: pointer;
        width: 74px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        background: #027bfe;
        border-radius: 4px;
      }
    }
  }
}

//续费/付费弹窗
.paid-top-title {
  text-align: center;
  font-size: 0.18rem;
  line-height: 0.24rem;
  color: #606060;
  margin-bottom: 0.2rem;

  @media screen and (max-width: 1367px) {
    margin-bottom: 0;
  }

  .paid-vip {
    // padding-left: 0.38rem;
    font-size: 0.2rem;
    color: #222;
    line-height: 0.32rem;
    font-weight: bold;
    margin-bottom: 0.07rem;
  }
  i {
    display: inline-block;
    width: 0.26rem;
    height: 0.3rem;
    background: url("~@/assets/images/vip_sign.svg") no-repeat left center;
    background-size: 0.26rem 0.3rem;
    vertical-align: middle;
    margin-right: 0.12rem;
    &.is-expired {
      background: url("~@/assets/images/vip_sign_gray.svg") no-repeat left
        center;
      background-size: 0.26rem 0.3rem;
    }
  }
  span {
    vertical-align: middle;
  }
  .stu-qr-code{
    width: 1.6rem;
    height: 1.6rem;
  }
}
.paid-center-content {

  position: relative;
  flex: 1;
  overflow: auto;
  margin-top: 0.2rem;
  .paid-meal-wrap{
    display: flex;
    flex-direction: row;
  }
}
.paid-top-tips {
  font-size: 0.18rem;
  text-align: center;
  padding: 0.18rem 0.3rem;
  line-height: 0.32rem;
  background: #fceed2;
  color: #cb9248;
}
.paid-title-p {
  color: #222;
  font-size: 0.16rem;
  margin-bottom: 0.16rem;
  font-weight: bold;
  span {
    color: #606060;
    font-size: 0.14rem;
    font-weight: normal;
  }
}
.paid-common-box {
  margin-bottom: 0.3rem;
}
.paid-meal {
  flex: 1;
  overflow-y: auto;
  max-height: 280px;
  display: block;
  //flex-direction:row;
  @media screen and (max-width: 1367px) {
    max-height: 150px;
  }
}
.meal-list-item {
  width: 200px;
  display: inline-block;
  //width: calc(33% - 0.2rem);
  height: 1.2rem;
  padding: 0.16rem 0;
  margin-right: 0.3rem;
  margin-bottom: 0.1rem;
  border: 1px solid #e3ddc7;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  &:nth-of-type(3n) {
    margin-right: 0;
  }
  .pay-month {
    color: #222;
    line-height: 0.24rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .pay-amount {
    font-size: 0.18rem;
    line-height: 0.4rem;
    color: #ddb16c;
    span {
      font-size: 0.32rem;
    }
  }
  .cut-count {
    width: 50%;
    margin: 0 auto;
    font-size: 0.12rem;
    border-radius: 0.1rem;
    line-height: 0.2rem;
    padding: 0 0.1rem;
    color: #ddb16c;
    background: #ddb16c33;
  }
  &.active {
    position: relative;
    border-color: #cb9248;
    &::after {
      content: "";
      position: absolute;
      top: -1px;
      right: 0;
      display: inline-block;
      width: 0.24rem;
      height: 0.24rem;
      background: url("~@/assets/images/select_sign.svg") no-repeat center;
      background-size: 0.24rem 0.24rem;
    }
  }
}
.redemption-code-input {
  display: inline-block;
  height: 0.56rem;
  line-height: 0.56rem;
  border: 1px solid #e3ddc7;
  color: #909090;
  .el-input {
    display: inline-block;
    width: 2.28rem;
    border: 0 none;
  }
  /deep/.el-input__inner {
    width: 100%;
    border: 0 none;
  }
  span {
    display: inline-block;
    width: 0.83rem;
    height: 100%;
    text-align: center;
    border-left: 1px solid #e3ddc7;
    cursor: pointer;
    &.active {
      background: #cb9248;
      color: #fff;
    }
  }
}
.paid-methods-way {
  display: inline-block;
  width: 2.2rem;
  height: 0.56rem;
  line-height: 0.56rem;
  border: 1px solid #e3ddc7;
  text-align: center;
  color: #222;
  font-size: 0.16rem;
  cursor: pointer;
  i {
    display: inline-block;
    width: 0.24rem;
    height: 0.24rem;
    background: url("~@/assets/images/wechat_pay_ico.svg") no-repeat center;
    background-size: 0.24rem 0.24rem;
    margin-right: 0.08rem;
    vertical-align: middle;
  }
  &.active {
    position: relative;
    border-color: #cb9248;
    &::after {
      content: "";
      position: absolute;
      top: -1px;
      right: -1px;
      display: inline-block;
      width: 0.24rem;
      height: 0.24rem;
      background: url("~@/assets/images/select_sign.svg") no-repeat center;
      background-size: 0.24rem 0.24rem;
    }
  }
}
.paid-code-img {
  position: absolute;
  right: 0.1rem;
  bottom: 0.6rem;
  width: 2.2rem;
  text-align: center;
  img {
    width: 1.8rem;
    height: 100%;
  }
  h6 {
    font-size: 16px;
    text-align: center;
    color: #222222;
    span {
      font-size: 18px;
    }
    i {
      font-style: normal;
      font-size: 32px;
    }
  }
  p {
    text-align: center;
    font-size: 12px;
    color: #606060;
  }
}
@media screen and (max-width: 1367px) {
  .akadm-middle-modal {
    /deep/.el-dialog__headerbtn {
      right: 0.16rem;
      top: 0.16rem;
    }
    /deep/.el-icon-close {
      font-size: 0.2rem;
    }
    /deep/.el-dialog {
      width: 6.46rem;
    }
    /deep/.el-dialog__body {
      padding: 0 0.3rem 0.2rem 0.3rem;
    }
  }
  .paid-code-img {
    width: 1.8rem;
    img {
      width: 1.4rem;
      height: 1.4rem;
    }
    h6 {
      font-size: 14px;
      span {
        font-size: 16px;
      }
      i {
        font-size: 26px;
      }
    }
  }
  .modal-top {
    width: 100%;
    height: 2.4rem;
  }
  .modal-center {
    font-size: 0.18rem;
    .last-p {
      font-size: 0.16rem;
      margin: 0.16rem 0;
    }
  }
  .paid-top-title {
    font-size: 0.14rem;
    i {
      width: 0.24rem;
      height: 0.28rem;
      background-size: 0.24rem 0.28rem;
      margin-right: 0.05rem;
    }
    .paid-vip {
      line-height: 0.26rem;
      font-size: 0.16rem;
    }
  }

  .paid-top-tips {
    padding: 0.1rem 0.24rem;
    line-height: 0.26rem;
    font-size: 0.14rem;
  }
  .paid-common-box {
    margin-bottom: 0.2rem;
    &:last-of-type {
      margin-bottom: 0.3rem;
    }
  }
  .paid-title-p {
    margin-bottom: 0.1rem;
  }
  .meal-list-item {
    padding: 0.1rem 0;
    height: 1rem;
    .pay-amount {
      line-height: 0.34rem;
      font-size: 0.16rem;
      span {
        font-size: 0.26rem;
      }
    }
    .cut-count {
      width: max-content;
    }
  }
  .paid-methods-way {
    height: 0.44rem;
    line-height: 0.44rem;
  }
  .redemption-code-input {
    height: 0.44rem;
    line-height: 0.44rem;
    /deep/.el-input__inner,
    .el-input {
      height: 0.38rem;
      line-height: 0.38rem;
    }
  }
}

// @media screen and (max-height: 736px) {
// }
</style>
